require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./4-everything-is-smooth.json") })
        }
      }, "path---4-everything-is-smooth");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---4-everything-is-smooth!./.cache/json/4-everything-is-smooth.json
// module id = 773
// module chunks = 231608221292675